import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { Modal, Button, Form, InputGroup, FormControl } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Swal from "sweetalert2";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
} from "@tanstack/react-table";
import "./user.css";

function Userlist() {
  const accessuserid = localStorage.getItem("id");
  const accesstoken = localStorage.getItem("token");

  // Tab state
  const [activeTab, setActiveTab] = useState("Users");

  // User states
  const [users, setUsers] = useState([]);
  const [User, setUser] = useState(false);
  const [username, setusername] = useState("");
  const [disname, setdisname] = useState("");
  const [userpassword, setuserpassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userroleAdd, setUserroleAdd] = useState("");

  // User edit states
  const [eduser, seteduser] = useState(false);
  const [userid, setuserid] = useState("");
  const [usernameedit, setusernameedit] = useState("");
  const [disnameedit, setdisnameedit] = useState("");
  const [passeedit, setpasseedit] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [status, setstatus] = useState("");

  // Role states
  const [roleData, setRoleData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [showRole, setShowRole] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roleDescription, setRoleDescription] = useState("");

  // Role edit states
  const [isEditRoleModalOpen, setIsEditRoleModalOpen] = useState(false);
  const [editRoleId, setEditRoleId] = useState("");
  const [editRoleName, setEditRoleName] = useState("");
  const [editRoleDescription, setEditRoleDescription] = useState("");
  const [editRoleStatus, setEditRoleStatus] = useState("");

  // Loading state
  const [loading, setLoading] = useState(false);

  // TanStack Table states for Users
  const [usersGlobalFilter, setUsersGlobalFilter] = useState("");
  const [usersSorting, setUsersSorting] = useState([]);
  const [usersPageSize, setUsersPageSize] = useState(10);
  const [usersPageIndex, setUsersPageIndex] = useState(0); // FIX: track page index in state

  // TanStack Table states for Roles
  const [rolesGlobalFilter, setRolesGlobalFilter] = useState("");
  const [rolesSorting, setRolesSorting] = useState([]);
  const [rolesPageSize, setRolesPageSize] = useState(10);
  const [rolesPageIndex, setRolesPageIndex] = useState(0); // FIX: track page index in state

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Fetch all users
  const GetAllUsers = () => {
    setLoading(true);
    axios
      .get(baseurladdress + "users/findallusers", {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        setUsers(Array.isArray(res.data.users) ? res.data.users : []);
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load users", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Fetch all roles
  const GetAllRoles = () => {
    setLoading(true);
    axios
      .get(baseurladdress + "users/findallroles", {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        setRoleData(Array.isArray(res.data.roles) ? res.data.roles : []);
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load roles", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Fetch active roles for dropdown
  const getRoles = () => {
    axios
      .get(baseurladdress + "users/activeRoles", {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        setRoles(Array.isArray(res.data.roles) ? res.data.roles : []);
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load roles", "error");
      });
  };

  useEffect(() => {
    GetAllUsers();
    GetAllRoles();
    getRoles();
  }, []);

  // User columns definition
  const usersColumns = useMemo(
    () => [
      {
        header: "Sl No",
        size: 80,
        cell: ({ row, table }) => {
          const pageIndex = table.getState().pagination.pageIndex;
          const pageSize = table.getState().pagination.pageSize;
          return pageIndex * pageSize + row.index + 1;
        },
      },
      {
        accessorKey: "user_name",
        header: "User Name",
        size: 200,
      },
      {
        accessorKey: "user_staffname",
        header: "Display Name",
        size: 200,
      },
      {
        accessorKey: "role_name",
        header: "Role",
        size: 150,
      },
      {
        accessorKey: "actions",
        header: "Actions",
        enableSorting: false,
        size: 80,
        cell: ({ row }) => (
          <div className="d-flex gap-2">
            <Icon.PencilSquare
              size={14}
              className="text-primary"
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEditClick(row.original.user_id)}
            />
            <Icon.Trash
              size={14}
              className="text-danger"
              title="Delete"
              style={{ cursor: "pointer" }}
              onClick={() => handleDeleteUser(row.original.user_id)}
            />
          </div>
        ),
      },
    ],
    []
  );

  // Roles columns definition
  const rolesColumns = useMemo(
    () => [
      {
        header: "Sl No",
        size: 80,
        cell: ({ row, table }) => {
          const pageIndex = table.getState().pagination.pageIndex;
          const pageSize = table.getState().pagination.pageSize;
          return pageIndex * pageSize + row.index + 1;
        },
      },
      {
        accessorKey: "role_name",
        header: "Role Name",
        size: 200,
      },
      {
        accessorKey: "role_description",
        header: "Description",
        size: 300,
      },
      {
        accessorKey: "actions",
        header: "Actions",
        enableSorting: false,
        size: 80,
        cell: ({ row }) => (
          <div className="d-flex gap-2">
            <Icon.PencilSquare
              className="text-primary"
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleRoles(row.original.role_id)}
            />
            <Icon.Trash
              className="text-danger"
              title="Delete"
              style={{ cursor: "pointer" }}
              onClick={() => deleteroles(row.original.role_id)}
            />
          </div>
        ),
      },
    ],
    []
  );

  // FIX: Users table instance — pageIndex now driven by state via onPaginationChange
  const usersTable = useReactTable({
    data: users,
    columns: usersColumns,
    state: {
      globalFilter: usersGlobalFilter,
      sorting: usersSorting,
      pagination: {
        pageIndex: usersPageIndex,
        pageSize: usersPageSize,
      },
    },
    onGlobalFilterChange: setUsersGlobalFilter,
    onSortingChange: setUsersSorting,
    onPaginationChange: (updater) => {
      const next =
        typeof updater === "function"
          ? updater({ pageIndex: usersPageIndex, pageSize: usersPageSize })
          : updater;
      setUsersPageIndex(next.pageIndex);
      setUsersPageSize(next.pageSize);
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  // FIX: Roles table instance — pageIndex now driven by state via onPaginationChange
  const rolesTable = useReactTable({
    data: roleData,
    columns: rolesColumns,
    state: {
      globalFilter: rolesGlobalFilter,
      sorting: rolesSorting,
      pagination: {
        pageIndex: rolesPageIndex,
        pageSize: rolesPageSize,
      },
    },
    onGlobalFilterChange: setRolesGlobalFilter,
    onSortingChange: setRolesSorting,
    onPaginationChange: (updater) => {
      const next =
        typeof updater === "function"
          ? updater({ pageIndex: rolesPageIndex, pageSize: rolesPageSize })
          : updater;
      setRolesPageIndex(next.pageIndex);
      setRolesPageSize(next.pageSize);
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  // Add user
  const handleUserSubmit = (e) => {
    e.preventDefault();

    if (!username || !disname || !userpassword || !userroleAdd) {
      Swal.fire("Warning", "All fields required", "warning");
      return;
    }

    const payload = {
      user_name: username,
      user_display: disname,
      user_password: userpassword,
      user_role: userroleAdd,
      user_crtby: accessuserid,
    };

    axios
      .post(baseurladdress + "users/adduser", payload, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          Swal.fire("Success", "User added successfully", "success");
          setUser(false);
          setusername("");
          setdisname("");
          setuserpassword("");
          setUserroleAdd("");
          GetAllUsers();
        } else {
          Swal.fire("Error", "Failed to add user", "error");
        }
      });
  };

  // Add role
  const handleRoleSubmit = (e) => {
    e.preventDefault();

    if (!roleName || !roleDescription) {
      Swal.fire("Warning", "All fields required", "warning");
      return;
    }

    const payload = {
      role_name: roleName,
      role_description: roleDescription,
      role_crtby: accessuserid,
    };

    axios
      .post(baseurladdress + "users/addrole", payload, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          Swal.fire("Success", "Role added successfully", "success");
          setShowRole(false);
          setRoleName("");
          setRoleDescription("");
          GetAllRoles();
        } else {
          Swal.fire("Error", "Failed to add role", "error");
        }
      });
  };

  // Edit user modal
  const handleEditClick = (userId) => {
    seteduser(true);
    setuserid(userId);
    console.log(userId, "userIduserIduserId");
    axios
      .get(baseurladdress + `users/edituser/` + userId, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        setusernameedit(data[0].user_name);
        setdisnameedit(data[0].user_staffname);
        setSelectedRole(data[0].user_role);
        setpasseedit(data[0].user_pass);
        setstatus(data[0].user_status);
      })
      .catch((error) => {
        Swal.fire("Error", "Failed to load user data", "error");
      });
  };

  // Update user
  const handleUserUpdate = (e) => {
    e.preventDefault();
    const data = {
      user_name: usernameedit,
      user_display: disnameedit,
      user_role: selectedRole,
      user_password: passeedit,
      user_status: status,
      user_updby: accessuserid,
      user_id: userid,
    };
    axios
      .post(baseurladdress + `users/updateuser`, data, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((result) => {
        const Data = result.data.status;
        if (Data === "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: "User Data Updated successfully",
          });
          seteduser(false);
          GetAllUsers();
        } else {
          Swal.fire("Error", "Failed to update user", "error");
        }
      })
      .catch((error) => {
        Swal.fire("Error", "An error occurred", "error");
      });
  };

  // Edit role modal
  const handleRoles = (role_id) => {
    console.log("role_id+" + role_id);
    setIsEditRoleModalOpen(true);
    setEditRoleId(role_id);

    axios
      .get(baseurladdress + `users/editroles/` + role_id, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response;
        console.log("Role data:", data);
        setEditRoleName(data.role_name);
        setEditRoleDescription(data.role_description);
        setEditRoleStatus(String(data.role_status));
      })
      .catch((error) => {
        Swal.fire("Error", "Failed to load role data", "error");
      });
  };

  // Update role
  const handleRoleUpdate = (e) => {
    e.preventDefault();

    const data = {
      role_name: editRoleName,
      role_description: editRoleDescription,
      role_status: editRoleStatus,
      role_updby: accessuserid,
      role_id: editRoleId,
    };

    axios
      .post(baseurladdress + "users/updateroles", data, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((result) => {
        if (result.data.status === "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Role updated successfully",
          });

          setIsEditRoleModalOpen(false);
          GetAllRoles();
        } else {
          Swal.fire("Error", result.data.message || "Something went wrong", "error");
        }
      })
      .catch((err) => {
        Swal.fire("Error", "An error occurred", "error");
      });
  };

  // Delete user
  async function handleDeleteUser(user_id) {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await axios.post(`${baseurladdress}users/deleteuser/${user_id}`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.data.status === "success") {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        });
        GetAllUsers();
      } else {
        Swal.fire("Error", response.data.message || "Something went wrong", "error");
      }
    } catch (err) {
      console.error("Delete user error:", err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  }

  // Delete role
  function deleteroles(role_id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(baseurladdress + `users/deleteroles/${role_id}`, {}, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            if (response.data.status === "success") {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
              });
              Toast.fire({
                icon: "success",
                title: "Role deleted successfully",
              });
              GetAllRoles();
            } else {
              Swal.fire("Error", response.data.message || "Something went wrong", "error");
            }
          })
          .catch((err) => {
            console.error("Delete role error:", err);
            Swal.fire("Error", "Something went wrong", "error");
          });
      }
    });
  }

  return (
    <div className="content-wrap">
      <div className="main">
        <div className="container-fluid">
          <section id="main-content">
            <div className="card">

              <div className="card-header bg-primary text-white d-flex flex-column flex-md-row gap-2 justify-content-between align-items-start align-items-md-center py-3">
                <h6 className="mb-0">USER & ROLE MANAGEMENT</h6>

                <ul className="nav nav-tabs border-0 mb-0">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "Users" ? "active" : ""}`}
                      onClick={() => setActiveTab("Users")}
                      style={{
                        color: activeTab === "Users" ? "#0d6efd" : "#fff",
                        backgroundColor: activeTab === "Users" ? "#fff" : "transparent",
                        border: activeTab === "Users"
                          ? "1px solid #dee2e6"
                          : "1px solid transparent",
                        borderBottom: activeTab === "Users" ? "1px solid #fff" : "none",
                      }}
                    >
                      Users
                    </button>
                  </li>

                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "Roles" ? "active" : ""}`}
                      onClick={() => setActiveTab("Roles")}
                      style={{
                        color: activeTab === "Roles" ? "#0d6efd" : "#fff",
                        backgroundColor: activeTab === "Roles" ? "#fff" : "transparent",
                        border: activeTab === "Roles"
                          ? "1px solid #dee2e6"
                          : "1px solid transparent",
                        borderBottom: activeTab === "Roles" ? "1px solid #fff" : "none",
                      }}
                    >
                      Roles
                    </button>
                  </li>
                </ul>
              </div>

              <div className="card-body">
                {/* Users Tab */}
                {activeTab === "Users" && (
                  <section>
                    <div className="card border-0">
                      <div className="card-body">
                        <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-stretch align-items-md-center mb-3">

                          <div className="d-flex gap-2 align-items-center">
                            <span>Show</span>
                            <Form.Select
                              style={{ width: "auto" }}
                              value={usersPageSize}
                              onChange={(e) => {
                                const size = Number(e.target.value);
                                setUsersPageSize(size);
                                setUsersPageIndex(0);
                                usersTable.setPageSize(size);
                              }}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </Form.Select>
                            <span>entries</span>
                          </div>

                          <InputGroup className="w-100 w-md-auto" style={{ maxWidth: "300px" }}>
                            <FormControl
                              placeholder="Search users..."
                              value={usersGlobalFilter ?? ""}
                              onChange={(e) => {
                                setUsersGlobalFilter(e.target.value);
                                setUsersPageIndex(0); // FIX: reset to page 1 on search
                              }}
                            />
                            <Button variant="outline-secondary">
                              <Icon.Search size={16} />
                            </Button>
                          </InputGroup>

                          <Button
                            variant="primary"
                            onClick={(e) => {
                              setUser(true);
                              e.currentTarget.blur();
                            }}
                          >
                            <Icon.Plus size={18} className="me-1" />
                            Add
                          </Button>
                        </div>

                        {loading ? (
                          <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="table-responsive">
                              <table className="table table-hover table-sm align-middle">
                                <thead className="table-light">
                                  {usersTable.getHeaderGroups().map((headerGroup) => (
                                    <tr key={headerGroup.id}>
                                      {headerGroup.headers.map((header) => (
                                        <th
                                          key={header.id}
                                          style={{ width: header.getSize() }}
                                          className="text-nowrap"
                                        >
                                          {header.isPlaceholder ? null : (
                                            <div
                                              {...{
                                                className: header.column.getCanSort()
                                                  ? "cursor-pointer select-none d-flex align-items-center"
                                                  : "",
                                                onClick: header.column.getToggleSortingHandler(),
                                              }}
                                            >
                                              {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                              )}
                                              {header.column.getCanSort() && (
                                                <span className="ms-1">
                                                  {{
                                                    asc: <Icon.ChevronUp size={12} />,
                                                    desc: <Icon.ChevronDown size={12} />,
                                                  }[header.column.getIsSorted()] ?? (
                                                    <Icon.ChevronExpand size={12} className="text-muted" />
                                                  )}
                                                </span>
                                              )}
                                            </div>
                                          )}
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody>
                                  {usersTable.getRowModel().rows.length > 0 ? (
                                    usersTable.getRowModel().rows.map((row) => (
                                      <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                          <td key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                          </td>
                                        ))}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={usersColumns.length} className="text-center text-muted py-4">
                                        No users found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* Pagination */}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div className="text-muted small">
                                Showing{" "}
                                {usersTable.getState().pagination.pageIndex *
                                  usersTable.getState().pagination.pageSize +
                                  1}{" "}
                                to{" "}
                                {Math.min(
                                  (usersTable.getState().pagination.pageIndex + 1) *
                                    usersTable.getState().pagination.pageSize,
                                  usersTable.getFilteredRowModel().rows.length
                                )}{" "}
                                of {usersTable.getFilteredRowModel().rows.length} entries
                              </div>

                              <div className="btn-group btn-group-sm">
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => usersTable.setPageIndex(0)}
                                  disabled={!usersTable.getCanPreviousPage()}
                                >
                                  <Icon.ChevronDoubleLeft size={14} />
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => usersTable.previousPage()}
                                  disabled={!usersTable.getCanPreviousPage()}
                                >
                                  <Icon.ChevronLeft size={14} />
                                </Button>
                                <Button variant="outline-secondary" disabled>
                                  Page {usersTable.getState().pagination.pageIndex + 1} of{" "}
                                  {usersTable.getPageCount()}
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => usersTable.nextPage()}
                                  disabled={!usersTable.getCanNextPage()}
                                >
                                  <Icon.ChevronRight size={14} />
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={() =>
                                    usersTable.setPageIndex(usersTable.getPageCount() - 1)
                                  }
                                  disabled={!usersTable.getCanNextPage()}
                                >
                                  <Icon.ChevronDoubleRight size={14} />
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </section>
                )}

                {/* Roles Tab */}
                {activeTab === "Roles" && (
                  <section>
                    <div className="card border-0">
                      <div className="card-body">
                        <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-stretch align-items-md-center mb-3">

                          <div className="d-flex gap-2 align-items-center">
                            <span>Show</span>
                            <Form.Select
                              style={{ width: "auto" }}
                              value={rolesPageSize}
                              onChange={(e) => {
                                const size = Number(e.target.value);
                                setRolesPageSize(size);
                                setRolesPageIndex(0);
                                rolesTable.setPageSize(size);
                              }}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </Form.Select>
                            <span>entries</span>
                          </div>

                          <InputGroup style={{ maxWidth: "300px" }}>
                            <FormControl
                              placeholder="Search roles..."
                              value={rolesGlobalFilter ?? ""}
                              onChange={(e) => {
                                setRolesGlobalFilter(e.target.value);
                                setRolesPageIndex(0); // FIX: reset to page 1 on search
                              }}
                            />
                            <Button variant="outline-secondary">
                              <Icon.Search size={16} />
                            </Button>
                          </InputGroup>

                          <Button
                            variant="primary"
                            onClick={(e) => {
                              setShowRole(true);
                              e.currentTarget.blur();
                            }}
                          >
                            <Icon.Plus size={18} className="me-1" />
                            Add
                          </Button>
                        </div>

                        {loading ? (
                          <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="table-responsive">
                              <table className="table table-hover table-sm align-middle">
                                <thead className="table-light">
                                  {rolesTable.getHeaderGroups().map((headerGroup) => (
                                    <tr key={headerGroup.id}>
                                      {headerGroup.headers.map((header) => (
                                        <th
                                          key={header.id}
                                          style={{ width: header.getSize() }}
                                          className="text-nowrap"
                                        >
                                          {header.isPlaceholder ? null : (
                                            <div
                                              {...{
                                                className: header.column.getCanSort()
                                                  ? "cursor-pointer select-none d-flex align-items-center"
                                                  : "",
                                                onClick: header.column.getToggleSortingHandler(),
                                              }}
                                            >
                                              {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                              )}
                                              {header.column.getCanSort() && (
                                                <span className="ms-1">
                                                  {{
                                                    asc: <Icon.ChevronUp size={12} />,
                                                    desc: <Icon.ChevronDown size={12} />,
                                                  }[header.column.getIsSorted()] ?? (
                                                    <Icon.ChevronExpand size={12} className="text-muted" />
                                                  )}
                                                </span>
                                              )}
                                            </div>
                                          )}
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody>
                                  {rolesTable.getRowModel().rows.length > 0 ? (
                                    rolesTable.getRowModel().rows.map((row) => (
                                      <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                          <td key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                          </td>
                                        ))}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={rolesColumns.length} className="text-center text-muted py-4">
                                        No roles found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* Pagination */}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div className="text-muted small">
                                Showing{" "}
                                {rolesTable.getState().pagination.pageIndex *
                                  rolesTable.getState().pagination.pageSize +
                                  1}{" "}
                                to{" "}
                                {Math.min(
                                  (rolesTable.getState().pagination.pageIndex + 1) *
                                    rolesTable.getState().pagination.pageSize,
                                  rolesTable.getFilteredRowModel().rows.length
                                )}{" "}
                                of {rolesTable.getFilteredRowModel().rows.length} entries
                              </div>

                              <div className="btn-group btn-group-sm">
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => rolesTable.setPageIndex(0)}
                                  disabled={!rolesTable.getCanPreviousPage()}
                                >
                                  <Icon.ChevronDoubleLeft size={14} />
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => rolesTable.previousPage()}
                                  disabled={!rolesTable.getCanPreviousPage()}
                                >
                                  <Icon.ChevronLeft size={14} />
                                </Button>
                                <Button variant="outline-secondary" disabled>
                                  Page {rolesTable.getState().pagination.pageIndex + 1} of{" "}
                                  {rolesTable.getPageCount()}
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={() => rolesTable.nextPage()}
                                  disabled={!rolesTable.getCanNextPage()}
                                >
                                  <Icon.ChevronRight size={14} />
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={() =>
                                    rolesTable.setPageIndex(rolesTable.getPageCount() - 1)
                                  }
                                  disabled={!rolesTable.getCanNextPage()}
                                >
                                  <Icon.ChevronDoubleRight size={14} />
                                </Button>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </section>
                )}

                {/* Add User Modal */}
                <Modal
                  className="modal-size md modal-top-center"
                  show={User}
                  centered
                  onHide={() => setUser(false)}
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header>
                    <h6>ADD USER</h6>
                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => setUser(false)}
                    >
                      ×
                    </span>
                  </Modal.Header>

                  <Modal.Body className="css">
                    <form>
                      <div className="row">
                        <div className="col-md-12 mt-2">
                          <h6>User Name</h6>
                          <input
                            type="text"
                            className="form-control"
                            value={username}
                            onChange={(e) => setusername(e.target.value)}
                            placeholder="Enter username"
                            required
                          />
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Display Name</h6>
                          <input
                            type="text"
                            className="form-control"
                            value={disname}
                            onChange={(e) => setdisname(e.target.value)}
                            placeholder="Enter display name"
                          />
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Role</h6>
                          <select
                            className="form-control"
                            value={userroleAdd}
                            onChange={(e) => setUserroleAdd(e.target.value)}
                          >
                            <option value="" disabled>
                              Select role
                            </option>
                            {roles.map((r) => (
                              <option key={r.role_id} value={r.role_id}>
                                {r.role_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Password</h6>
                          <div className="input-group">
                            <input
                              type={passwordVisible ? "text" : "password"}
                              className="form-control"
                              value={userpassword}
                              onChange={(e) => setuserpassword(e.target.value)}
                              placeholder="Enter password"
                              required
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={togglePasswordVisibility}
                              >
                                <i
                                  className={passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"}
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>

                  <Modal.Footer>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleUserSubmit}
                    >
                      SAVE
                    </button>
                  </Modal.Footer>
                </Modal>

                {/* Add Role Modal */}
                <Modal
                  className="modal-size md modal-top-center"
                  show={showRole}
                  centered
                  onHide={() => setShowRole(false)}
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header>
                    <h6>ADD ROLE</h6>
                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowRole(false)}
                    >
                      ×
                    </span>
                  </Modal.Header>

                  <Modal.Body className="css">
                    <form>
                      <div className="row">
                        <div className="col-md-12 mt-2">
                          <h6>Role Name</h6>
                          <input
                            type="text"
                            className="form-control"
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}
                            placeholder="Enter role name"
                            required
                          />
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Role Description</h6>
                          <textarea
                            className="form-control"
                            rows="3"
                            value={roleDescription}
                            onChange={(e) => setRoleDescription(e.target.value)}
                            placeholder="Enter role description"
                          />
                        </div>
                      </div>
                    </form>
                  </Modal.Body>

                  <Modal.Footer>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleRoleSubmit}
                    >
                      SAVE
                    </button>
                  </Modal.Footer>
                </Modal>

                {/* Edit User Modal */}
                <Modal
                  className="modal-size md modal-top-center"
                  show={eduser}
                  centered
                  onHide={() => seteduser(false)}
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header>
                    <h6>EDIT USER</h6>
                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => seteduser(false)}
                    >
                      ×
                    </span>
                  </Modal.Header>

                  <Modal.Body className="css">
                    <form>
                      <div className="row">
                        <div className="col-md-12 mt-2">
                          <h6>User Name</h6>
                          <input
                            type="text"
                            className="form-control"
                            value={usernameedit}
                            onChange={(e) => setusernameedit(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Display Name</h6>
                          <input
                            type="text"
                            className="form-control"
                            value={disnameedit}
                            onChange={(e) => setdisnameedit(e.target.value)}
                          />
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Role</h6>
                          <select
                            className="form-control"
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                          >
                            <option value="" disabled>
                              Select role
                            </option>
                            {roles.map((r) => (
                              <option key={r.role_id} value={r.role_id}>
                                {r.role_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Password</h6>
                          <div className="input-group">
                            <input
                              type={passwordVisible ? "text" : "password"}
                              className="form-control"
                              value={passeedit}
                              onChange={(e) => setpasseedit(e.target.value)}
                              required
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={togglePasswordVisibility}
                              >
                                <i
                                  className={passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"}
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 mt-2">
                          <h6>Status</h6>
                          <select
                            className="form-control"
                            value={status}
                            onChange={(e) => setstatus(e.target.value)}
                          >
                            <option value="" disabled>
                              Select status
                            </option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>

                  <Modal.Footer>
                    <button className="btn btn-primary" onClick={handleUserUpdate}>
                      UPDATE
                    </button>
                  </Modal.Footer>
                </Modal>

                {/* Edit Role Modal */}
                <Modal
                  className="modal-size md modal-top-center"
                  show={isEditRoleModalOpen}
                  onHide={() => setIsEditRoleModalOpen(false)}
                  centered
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header>
                    <h6>EDIT ROLE</h6>
                    <span
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsEditRoleModalOpen(false)}
                    >
                      ×
                    </span>
                  </Modal.Header>

                  <Modal.Body>
                    <form>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h6>Role Name</h6>
                          <input
                            type="text"
                            className="form-control"
                            value={editRoleName}
                            onChange={(e) => setEditRoleName(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <h6>Role Description</h6>
                          <textarea
                            className="form-control"
                            value={editRoleDescription}
                            onChange={(e) => setEditRoleDescription(e.target.value)}
                            rows={3}
                            required
                          ></textarea>
                        </div>

                        <div className="col-md-12 mb-3">
                          <h6>Role Status</h6>
                          <select
                            className="form-control"
                            value={editRoleStatus}
                            onChange={(e) => setEditRoleStatus(e.target.value)}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-primary" onClick={handleRoleUpdate}>
                      UPDATE
                    </button>
                  </Modal.Footer>
                </Modal>

              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Userlist;